import { splitEmojiPrompt } from '@brainfart/shared';

// A question's prompt. An emoji puzzle ("Which movie is this? 🦁👑") shows its emoji big on a line of their own, so
// they read at a glance on a phone; every other prompt is plain text. The split is shared (shared/src/emoji-prompt.ts)
// with the question page and the video.
export function PromptText({ prompt }: { prompt: string }) {
  const parts = splitEmojiPrompt(prompt);
  if (!parts) return <>{prompt}</>;
  return (
    <>
      {parts.lead}
      <span data-testid="emoji-prompt" style={{ display: 'block', fontSize: '2.6em', lineHeight: 1.2, marginTop: '0.2em', letterSpacing: '0.06em', fontWeight: 400 }}>
        {parts.emoji}
      </span>
    </>
  );
}
